import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import SubCategoryList from '../../components/SubCategory/SubCategoryList';
const SubCategoryListPage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <SubCategoryList/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};
export default SubCategoryListPage;